const MEDIUM = 'medium'
const SMALL = 'small'

export const ICON_SIZES = {
  [MEDIUM]: 24,
  [SMALL]: 16,
}
